
















































import Button from '@/components/shared/atoms/Button/Button'

export default {
  components: {
    Button
  }
}
